import { Box, Typography, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from 'react-router-dom';
import useTitle from '../Hooks/useTitle';

const SuccessPayment = () => {
    useTitle('Payment Success');
    const Navigate = useNavigate();

    const goToHome = () => {
        Navigate('/');
    }
    return (
        <div className="flex justify-center items-center min-h-screen bg-gray-100">
            <Box
                className="bg-white p-8 sm:p-12 md:p-16 lg:p-20 rounded-lg shadow-md text-center"
                sx={{
                    width: {
                        xs: '90%',
                        sm: '80%',
                        md: '60%',
                    },
                }}
            >
                <Box className="flex justify-center mb-6">
                    <CheckCircleIcon className="text-green-500" sx={{ fontSize: { xs: 50, sm: 70, md: 100 } }} />
                </Box>
                <Typography
                    variant="h4"
                    component="h1"
                    sx={{
                        fontWeight: 'bold',
                        mb: 2,
                        fontSize: { xs: 'h5', sm: 'h4' },
                    }}
                >
                    Payment Successful
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        mb: 4,
                        fontSize: { xs: 'body2', sm: 'body1' },
                    }}
                >
                    Thank you for your payment! Your transaction has been completed successfully.
                </Typography>

                <Box>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{
                            padding: { xs: '8px 20px', sm: '10px 30px' },
                        }}
                        onClick={goToHome}
                    >
                        Go to Home
                    </Button>
                </Box>
            </Box>
        </div>
    );
};

export default SuccessPayment;
